import { observer } from "mobx-react-lite";
import theme from "../../themes/theme";
import Button from "../Button";

const NewCustomerButton = () => {
   return (
      <Button size="regular" variant="tertiary" as="a" href={theme.newCustomerForm}>
         Bli kunde
      </Button>
   );
};

export default observer(NewCustomerButton);
